// Used to add min height to element which matches the width. (creates a square when dynamic content is in use)
$(window).on('load resize', function () {

    $('.js-match-width').each(function () {
        $this = $(this);
        imageWidth = $this.outerWidth();

        $this .css('min-height', imageWidth + 'px');
    });

}).resize();
